<template>
  <div class="mx-2">
    <icon-view
      class="mr-2 mt-1 rounded-circle icon-view-color-text"
      icon="fas fa-file-search pl-1"
      icon-background="white"
      icon-color="#ff7058"
      icon-size="16px"
      title="Gestionar"
    />
    <div class="mt-3 mx-3">
      <validation-observer ref="requestProcedureFormRef" tag="form" novalidate>
        <validation-provider v-slot="{ errors }" rules="required">
          <span class="data-title d-block mb-2">Tipo de Gestión:</span>
          <CustomInput
            id="txtProcedureType"
            v-model="model.procedureType"
            maxlength="500"
            custom-error-msg="El tipo de gestión es requerido."
            :error="errors[0]"
          />
        </validation-provider>
        <div class="mt-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <span class="data-title d-block mb-2">Comentario:</span>
            <custom-text-area
              id="txtProcedureComment"
              class="textarea__extended"
              v-model="model.comment"
              :maxlength="3000"
              show-char-count
              :count-classes="['d-block text-left']"
              :error="errors[0]"
              custom-error-msg="El comentario es requerido."
            />
          </validation-provider>
        </div>
        <div class="mt-2 d-flex flex-column flex-lg-row justify-content-lg-end">
          <action-button
            id="btnCancel"
            text="Cancelar"
            variant="outline-danger"
            i="fas fa-times-circle"
            class="w-auto w-lg-0"
            @click="onCancelHandler"
          />
          <div class="my-1 mx-1 my-lg-0 mx-lg-2" />
          <action-button
            id="btnSave"
            text="Guardar"
            variant="success"
            i="fas fa-save"
            class="w-auto w-lg-0"
            @click="onSaveHandler"
          />
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
//libs
import IconView from "icon-view";
import CustomInput from "CustomInput";
import CustomTextArea from "CustomTextArea";
import ActionButton from "ActionButton";

//mixins
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";

//services
import referralStudentService from "@/services/pc/referral-student";

//constants
import { publicPortalRequestTypes } from "@/utils/constants/student/publicPortalRequestTypes.js";

export default {
  name: "RequestProcedureAdd",
  mixins: [alertMixin],
  components: {
    IconView,
    CustomInput,
    CustomTextArea,
    ActionButton
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    requestTypeId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    model: {
      procedureType: null,
      comment: null
    }
  }),
  computed: {
    isOnLineRegistration() {
      return this.requestTypeId === publicPortalRequestTypes.OnlineRegistration;
    }
  },
  methods: {
    onCancelHandler() {
      this.$emit("cancel");
    },
    async onSaveHandler() {
      const isValid = await this.$refs.requestProcedureFormRef.validate();

      if (!isValid) {
        this.ShowToast("Error", "Informacion incompleta.", "error");
        return;
      }

      var payload = {
        id: this.id,
        isOnLineRegistration: this.isOnLineRegistration,
        procedureType: this.model.procedureType,
        comment: this.model.comment
      };

      await referralStudentService
        .saveRequestProcedure(payload)
        .then(result => {
          if (result.data) {
            this.ShowToast(
              "Confirmación",
              "La gestión ha sido realizada exitosamente.",
              "success"
            );
            this.$emit("saved");
          }
        })
        .catch(error => {
          this.ShowToast("Error", error.response.data.message, "error");
        });
    }
  }
};
</script>

<style scoped lang="scss">
.textarea__extended ::v-deep {
  .position-relative {
    i {
      display: none;
    }
  }
}
</style>
